<template>
  <div class="search-com">
    <TxInput
      v-model="search_text"
      src="rank_sousuokuang-liebiao"
      @enter="(e) => doSearch()"
    />
    <TxBtn
      src="rank_sousuoanniu-liebiao"
      class="search-btn"
      @click="doSearch"
      name="搜索"
    />
  </div>
</template>
<script setup>
import { useRoute, useRouter } from 'vue-router';
import config from '@img/config.json';
import px2vw from '@/utils/px2vw_v2';
import { ref } from 'vue';
const { support_image, is_mobile } = inject('GlobalStore');
const { search_record, set_search_record } = inject('GlobalData');

const emit = defineEmits(['doSearch']);

const props = defineProps({
  src: {
    type: String,
    required: true,
  },
  name: {
    type: String,
    required: false,
  },
  redirect: {
    type: Boolean,
    default: true,
  },
});

const route = useRoute();
const router = useRouter();

const search_text = ref('');

const bg = computed(() => {
  let src = config[props.src].src;
  return `${src}.${support_image.value}`;
});

const doSearch = () => {
  console.log('emit doSearch', props.redirect);
  //

  if (props.redirect) {
    router.push({
      path: `/search`,
      query: {
        name: search_text.value,
      },
    });
  } else {
    console.log('doSearch emit', search_text.value);
    set_search_record(search_text.value);
    emit('doSearch', search_text.value);
  }
};
</script>
<style scoped>
.search-com {
  position: relative;
  display: inline-flex;
  align-items: center;
}

.search-btn {
  margin-left: -32px;
  margin-top: 10px;
}
</style>
